import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-4e6fb3a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = { class: "left-container" };
const _hoisted_3 = { class: "center-container" };
const _hoisted_4 = {
    id: "MainTitle",
    class: "text-lg sm:text-xl md:text-2xl"
};
const _hoisted_5 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_6 = { class: "text-md sm:text-xl md:text-2xl" };
const _hoisted_7 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_8 = {
    href: "mailto:commercial@ficos.com",
    class: "inline-flex text-sm sm:text-base items-center font-medium hover:underline",
    style: { "color": "#00997c" }
};
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    "aria-hidden": "true",
    class: "w-5 h-5 ml-1",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
}, null, -1));
const _hoisted_10 = { class: "right-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_button = _resolveComponent("hit-button");
    const _component_hit_select = _resolveComponent("hit-select");
    const _component_hit_input = _resolveComponent("hit-input");
    const _component_hit_form = _resolveComponent("hit-form");
    const _component_hit_panel = _resolveComponent("hit-panel");
    const _component_hit_dialog = _resolveComponent("hit-dialog");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_hit_button, {
                    "suffix-icon": "back",
                    "icon-size": "lg",
                    color: "accent",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('previousClick')))
                })
            ]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('admin-ui.vat_form_vat_number')), 1),
                _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.vat_form_select_country_in_which_your_company_is_based')), 1),
                _createVNode(_component_hit_panel, {
                    size: "maximized",
                    resizable: false
                }, {
                    body: _withCtx(() => [
                        _createVNode(_component_hit_form, {
                            name: "CheckVatForm",
                            value: _ctx.objectFormData,
                            validations: _ctx.validations,
                            "force-cancel-button-hidden": true,
                            "force-save-button-hidden": true
                        }, {
                            default: _withCtx(({ formData, validationState }) => [
                                _createVNode(_component_hit_select, {
                                    name: "country",
                                    class: "text-sm sm:text-base",
                                    value: formData.country,
                                    "label-fields": _ctx.getDesignationForCurrentLocale,
                                    options: _ctx.countries,
                                    clearable: false,
                                    label: _ctx.t('admin-ui.country'),
                                    "validation-state": validationState.country,
                                    filterable: true,
                                    onChange: _ctx.onChangeCountry
                                }, null, 8, ["value", "label-fields", "options", "label", "validation-state", "onChange"]),
                                _createVNode(_component_hit_input, {
                                    name: "vatNumber",
                                    class: "text-sm sm:text-base",
                                    value: formData.vatNumber,
                                    "validation-state": validationState.vatNumber,
                                    label: _ctx.t('admin-ui.vat_number'),
                                    onInput: _ctx.onChangeVatNumber
                                }, null, 8, ["value", "validation-state", "label", "onInput"])
                            ]),
                            _: 1
                        }, 8, ["value", "validations"])
                    ]),
                    _: 1
                }),
                _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.t('admin-ui.vat_form_country_not_listed')), 1),
                _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.t('admin-ui.vat_form_send_email_to_our_sales_department')), 1),
                _createElementVNode("a", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.t('admin-ui.contact_us')) + " ", 1),
                    _hoisted_9
                ]),
                _createVNode(_component_hit_dialog, {
                    visible: _ctx.isCheckingVatApi,
                    title: _ctx.t('admin-ui.stepper_checking_vat'),
                    color: "accent",
                    "show-ok-button": false,
                    "show-cancel-button": false,
                    message: _ctx.t('admin-ui.your_vat_number_is_checked'),
                    "ok-button-color": "accent",
                    "enable-close-dialog": false
                }, null, 8, ["visible", "title", "message"])
            ]),
            _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_hit_button, {
                    color: "accent",
                    disabled: !_ctx.allowNextClick,
                    "suffix-icon": "forward",
                    "icon-size": "lg",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('nextClick', { countryCode: _ctx.objectFormData.country.substring(0, 2).toUpperCase(), vatNumber: _ctx.objectFormData.vatNumber })))
                }, null, 8, ["disabled"])
            ])
        ])
    ]));
}
